import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Handler from '../../Handler';
import API from '../../api';
import Utils from '../../api/Utils';
import { Button, CheckBox, TextInput } from '../../components';
import { LangContext, SnackbarContext, UserContext } from '../../contexts';
import { useForm } from '../../hooks';

export const UserLoginPage = (props) => {
  const history = useHistory();
  const { t } = useTranslation();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { updateAccessToken, updateRefreshToken } = useContext(UserContext);
  const { isKorean } = useContext(LangContext);
  const [formData, formMeta, formChange] = useForm(
    {
      email: '',
      password: '',
      keeping: false,
    },
    {
      email: {
        key: 'email',
        style: {
          marginBottom: 12,
        },
        className: 'round',
        required: true,
        placeholder: 'EMAIL_PLACEHOLDER',
      },
      password: {
        key: 'password',
        type: 'password',
        style: {},
        className: 'round',
        required: true,
        placeholder: 'PASSWORD_PLACEHOLDER',
      },
      keeping: {
        key: 'keeping',
        style: {},
        label: 'LOGGED_IN',
      },
    },
  );

  const ERROR_MESSAGES = {
    'Invalid user status - Certification': {
      ko: '이메일 인증이 처리되지 않았습니다.',
      en: 'Email verification is required',
    },
    'Invalid user status - ApproveRequired': {
      ko: '관리자 승인이 처리되지 않았습니다.',
      en: 'Admin approval is required',
    },
    'Invalid user status - Disabled': {
      ko: '사용 불가능한 유저 아이디입니다.',
      en: 'This user account is disabled',
    },
    'Not found user': {
      ko: '유효하지 않은 이메일입니다.',
      en: 'Invalid email address',
    },
    'Invalid password': {
      ko: '비밀번호를 확인하세요.',
      en: 'Invalid password',
    },
  };

    const getErrorMessage = (data, isKorean) => {
      const { fieldErrors, message } = data;
      console.log('전체 data:', data);
      console.log('fieldErrors:', fieldErrors);
      if (fieldErrors?.length) {
        return fieldErrors[0].reason;
      }

      // fieldErrors가 존재하고, 배열이며, 요소가 있는지 확인
      if (fieldErrors && Array.isArray(fieldErrors) && fieldErrors.length > 0) {
        if (fieldErrors[0]?.reason) {
          return fieldErrors[0].reason;
        }
      }

      if (ERROR_MESSAGES[message]) {
        return isKorean ? ERROR_MESSAGES[message].ko : ERROR_MESSAGES[message].en;
      }

      if (message === '존재하지 않는 이메일입니다.') {
        return isKorean ? message : 'The email does not exist.';
      }

      return message;
    };

  const requestLogin = () => {
    let body = Handler.formToBody(formData, formMeta);
    if (!body) {
      updateSnackbar({
        type: 'error',
        open: true,
        message: isKorean ? '필수정보를 확인해주세요.' : 'Please check the required information.',
      });
      return;
    }

    API.User.Signin(body)
      .then((res) => {
        let result = res.data;
        updateAccessToken(result.accessToken);
        updateRefreshToken(result.refreshToken);
        Utils.SetStorage('keeping', formData.keeping);
        history.push('/');
      })
      .catch((err) => {
        console.log('err.data', err.data);
        const message = getErrorMessage(err.data, isKorean);

        updateSnackbar({
          type: 'error',
          open: true,
          message,
        });

        if (err.data.message === 'Invalid user status - ApproveRequired') {
          history.push('/user/signup_complete');
        }
      });
  };

  return (
    <article className='basic-page'>
      <article className='content__wrapper'>
        <section className='headding-text__container'>
          <header>
            <h1>{t('LOGIN')}</h1>
          </header>
        </section>
        <section className='login-form__container'>
          <TextInput
            value={formData.email}
            onChange={formChange}
            meta={formMeta.email}
            onEnter={requestLogin}
          ></TextInput>
          <TextInput
            value={formData.password}
            onChange={formChange}
            meta={formMeta.password}
            onEnter={requestLogin}
          ></TextInput>
          <Button
            style={{ width: '100%', margin: '28px 0 16px' }}
            onClick={() => {
              requestLogin();
            }}
            label={t('LOGIN')}
          ></Button>
          <div className='option__box'>
            <CheckBox value={formData.keeping} onChange={formChange} meta={formMeta.keeping}></CheckBox>
            <ul>
              <li
                onClick={() => {
                  history.push('/user/find_pw');
                }}
              >
                <span>{t('FIND_PW')}</span>
              </li>
              <li
                onClick={() => {
                  history.push('/user/signup_guide');
                }}
              >
                <span>{t('SIGN_UP')}</span>
              </li>
            </ul>
          </div>
        </section>
      </article>
    </article>
  );
};
